<div class="fullscreen padd dark light animated fadeIn">
    <div class="dark2" style="text-align: center !important;">
        <a style="text-align: center !important;" class="navbar-brand light">IMPORTADOR DE ARCHIVOS DE AFIP - ( NOMINAS )</a>
    </div>
    <br>
    <div class="row">
        <br>  
        <div class="col-md-3">
            <h4><i class="far fa-file-alt"></i>&nbsp;Select files</h4>
            <span type="button" class="btn btn-light btn-xs"><input type="file" ng2FileSelect [uploader]="uploader" multiple  /><br/></span>
        </div>
        <div class="col-md-9" style="margin-bottom: 40px">
            <h3>Cola de Importación</h3>
            <p style="color: rgb(94, 61, 214);">A procesar: {{ uploader?.queue?.length }} archivos.</p>
            <table class="table light">
                <thead>
                    <tr>
                        <th width="25%">Nombre Archivo</th>
                        <th class="row3" width="25%">Resp. Servidor</th>
                        <th>Tamaño</th>
                        <th>Progreso</th>
                        <th>Status</th>
                        <th> Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of uploader.queue" class="animated fadeIn">
                        <td><strong><i><i class="far fa-file-alt"></i>{{ item?.file?.name }}</i></strong></td>
                        <td class="row3"><strong><i>{{ item.file ? array[item.file.name] : '-' }}</i></strong></td>
                        <td *ngIf="uploader.options.isHTML5" nowrap>{{ item?.file?.size/1024/1024 | number:'.2' }} MB</td>
                        <td *ngIf="uploader.options.isHTML5">
                            <div class="progress" style="margin-bottom: 0;">
                                <div class="progress-bar" role="progressbar" [ngStyle]="{ 'width': item.progress + '%' }"></div>
                            </div>
                        </td>
                        <td>
                            <div style="width: 65px;">
                                {{ item.progress }}%
                                <mat-icon class="animated fadeIn" *ngIf="item.isSuccess && array[item.file.name] === 'Importación Exitosa!'" style="color: rgb(46, 248, 46);">done</mat-icon>
                                <mat-icon class="animated fadeIn" *ngIf="item.isSuccess && array[item.file.name] === 'Archivo desprocesado!'" style="color: rgb(46, 191, 248);">done</mat-icon>
                                <mat-icon class="animated fadeIn" *ngIf="item.isError" style="color: red;" aria-label="Volver">error</mat-icon>
                            </div>
                        </td>
                        <td nowrap>
                            <button type="button" class="btn btn-success btn-xs"
                                (click)="uploadItem(item)" [disabled]="item.isReady || item.isUploading ">
                                    <i class="fas fa-upload"></i> Subir
                            </button>
                            <button type="button" class="btn btn-warning btn-xs"
                                (click)="item.cancel()" [disabled]="!item.isUploading">
                                    <i class="fas fa-stop-circle"></i>
                            </button>
                            <button type="button" class="btn btn-danger btn-xs"
                                (click)="item.remove(); clearItem(item.file.name);">
                                    <i class="fas fa-trash"></i>
                            </button>
                            <button type="button" class="btn btn-light btn-xs"
                                (click)="desprocesarItem( item )">
                                    <i class="fas fa-exchange-alt"></i> Despr.
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>

            <div>
                <div>
                    Progreso total:
                    <div class="progress">
                        <div class="progress-bar" role="progressbar" [ngStyle]="{ 'width': uploader.progress + '%' }"></div>
                    </div>
                </div>
                <br>
                <button type="button" class="btn btn-success btn-s"
                    (click)="uploadAll()" [disabled]="!uploader.getNotUploadedItems().length">
                        <i class="fas fa-cloud-upload-alt"></i> Importar todo
                </button>
                <button type="button" class="btn btn-warning btn-s"
                    (click)="uploader.cancelAll()" [disabled]="!uploader.isUploading">
                        <i class="fas fa-stop-circle"></i> Cancelar
                </button>
                <button type="button" class="btn btn-danger btn-s"
                    (click)="uploader.clearQueue(); clearAll();" [disabled]="!uploader.queue.length">
                        <i class="far fa-trash-alt"></i> Quitar todo
                </button>
                <button type="button" class="btn btn-light btn-s"
                    (click)="desprocesarTodo()" [disabled]="!uploader.getNotUploadedItems().length">
                        <i class="fas fa-exchange-alt"></i> Desprocesar todo
                </button>
            </div>
        </div>
    </div>

    <br>
    
    <div class="row2">
        <div class="col-md-12">
            <div class="panel panel-default">
                <div class="panel-heading">Ultimo archivo procesado:</div>
                <div class="panel-body">
                    <span *ngIf="ultimoProcesado">TXT-NOMINA: {{ ultimoProcesado.ULTIMO  | date:'dd-MM-yyyy' }}</span>
                    <i *ngIf="lUltimo" class="fa fa-spinner fa-spin fa-1x fa-fw"></i>
                    <mat-icon *ngIf="!lUltimo" class="animated fadeIn" style="color: rgb(46, 248, 46);">done</mat-icon>
                </div>
            </div>
        </div>
    </div>
</div>